import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

import MediaQuery from 'react-responsive';

import TextField from 'material-ui/TextField';

import { isFilterInStrings } from 'helpers/StringHelper.js';

import PropertyMultiSelect from 'components/shared/PropertyMultiSelect';
import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';
import TableToggle from 'components/shared/TableToggle';

import LogsTable from 'components/landlord_app/logs/LogsTable';
import LogsDialog from 'components/landlord_app/logs/LogsDialog';
import LogsDrawer from 'components/landlord_app/logs/LogsDrawer';

import { createOrUpdateLog, getLogs } from 'redux/logs/actions';
import { getProperties } from 'actions/landlordPropertiesActions';

export default connect(
  store => ({
    logs: store.logs.logs,
    properties: store.landlordProperties.properties,
  }),
  { createOrUpdateLog, getLogs, getProperties, submit }
)(
  class Templates extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        typeFilter: '',
        dialogOpen: false,
        drawerOpen: false,
        onlyShowUnreadLogs: true,
        selectedLog: {},
        selectedProperties: [],
      };

      this.props.getProperties({ for_multiselect: true });
      this.props.getLogs();
    }

    createOrUpdateLog = async formData => {
      if (formData.id) {
        formData.read = !formData.read;
      }

      const response = await this.props.createOrUpdateLog(formData);
      if (response) {
        this.setState({ dialogOpen: false, drawerOpen: false });
      }
    };

    addLog = () => {
      this.setState({ selectedLog: {} }, this.toggleDialog);
    };

    toggleDrawer = () => {
      this.setState(prevState => ({ drawerOpen: !prevState.drawerOpen }));
    };

    toggleDialog = () => {
      this.setState(prevState => ({ dialogOpen: !prevState.dialogOpen }));
    };

    openLog = selectedLog => {
      this.setState({ selectedLog }, this.toggleDrawer);
    };

    setTypeFilter = e => {
      this.setState({ typeFilter: e.target.value });
    };

    toggleReadFilter = () => {
      this.setState(prevState => ({ onlyShowUnreadLogs: !prevState.onlyShowUnreadLogs }));
    };

    setPropertyFilter = selectedProperties => this.setState({ selectedProperties });

    filteredData = () => {
      const { typeFilter, onlyShowUnreadLogs, selectedProperties } = this.state;
      let data = this.props.logs || [];

      data = data.filter(item => !onlyShowUnreadLogs || item.read === false);

      data = data.filter(item =>
        isFilterInStrings(
          [
            item.title,
            item.log_type_friendly,
            item.details,
            item.property_name,
            item.unit_name,
            item.reported_by,
          ],
          typeFilter
        )
      );

      if (selectedProperties.length > 0) {
        const selectedPropertyNames = selectedProperties.map(property => property.label);
        data = data.filter(log => selectedPropertyNames.includes(log.property_name));
      }

      return data;
    };

    render() {
      return (
        <div className="body" role="main">
          <div className="centers">
            <HeaderWithPeriod
              headerText="Shift Logs"
              actionButtonLabel="Add Log"
              toggleDialog={this.addLog}
            />

            <div className="row" style={{ height: 'calc(100% - 104px' }}>
              <div className="row" style={{ marginBottom: '15px' }}>
                <TextField
                  hintText="Filter by Name or Property"
                  style={{ fontSize: '13px', width: '200px' }}
                  value={this.state.typeFilter}
                  onChange={this.setTypeFilter}
                />

                <div className="row" style={{ marginBottom: '15px' }}>
                  <div style={{ width: '250px', float: 'right' }}>
                    <MediaQuery query="(min-device-width: 750px)">
                      <PropertyMultiSelect
                        onPropertySelect={this.setPropertyFilter}
                        properties={this.props.properties}
                        selectedProperties={this.state.selectedProperties}
                      />
                    </MediaQuery>
                  </div>

                  <div style={{ width: '135px' }}>
                    <TableToggle toggleAction={this.toggleReadFilter} toggleVerbiage="Show All" />
                  </div>
                </div>
              </div>

              <LogsTable
                data={this.filteredData()}
                openLog={this.openLog}
                createOrUpdateLog={this.props.createOrUpdateLog}
              />
            </div>

            <LogsDialog
              open={this.state.dialogOpen}
              toggleOpen={this.toggleDialog}
              data={this.state.selectedLog}
              submit={() => this.props.submit('add_log_form')}
              createOrUpdateLog={this.createOrUpdateLog}
            />

            <LogsDrawer
              open={this.state.drawerOpen}
              toggleOpen={this.toggleDrawer}
              data={this.state.selectedLog}
              createOrUpdateLog={this.createOrUpdateLog}
            />
          </div>
        </div>
      );
    }
  }
);
